<template>
	<div class="Center">
		<common-body aside="7">
			<div slot="commonMain" class="acct-page">
				<div class="acct-panel" v-loading="loading">
					<header class="acct-head">
						<div class="acct-head__titles">
							<h1 class="acct-head__title">个人中心</h1>
							<p class="acct-head__sub">管理账号资料与登录密码</p>
						</div>
						<nav class="acct-nav">
							<button
								type="button"
								class="acct-nav__item"
								:class="{ 'is-active': centerStatus == 1 }"
								data-url="/center"
								data-status="1"
								@click="goUrl"
							>用户信息</button>
							<button
								type="button"
								class="acct-nav__item"
								:class="{ 'is-active': centerStatus == 2 }"
								data-url="/passSet"
								data-status="2"
								@click="goUrl"
							>密码设置</button>
						</nav>
					</header>

					<section class="acct-profile">
						<div class="acct-profile__avatar">{{ userInitial }}</div>
						<div class="acct-profile__body">
							<div class="acct-profile__name">{{ displayName }}</div>
							<dl class="acct-meta">
								<div class="acct-meta__cell">
									<dt>账号</dt>
									<dd>{{ userInfo.username || '—' }}</dd>
								</div>
								<div class="acct-meta__cell">
									<dt>用户 ID</dt>
									<dd>{{ displayUserId }}</dd>
								</div>
								<div class="acct-meta__cell" v-if="Number(userInfo.dis_ratio) > 0">
									<dt>推广比例</dt>
									<dd>{{ userInfo.dis_ratio * 10 }}%</dd>
								</div>
								<div class="acct-meta__cell" v-if="Number(userInfo.pur_ratio) > 0">
									<dt>采购比例</dt>
									<dd>{{ userInfo.pur_ratio * 10 }}%</dd>
								</div>
							</dl>
						</div>
					</section>

					<p class="acct-note">如果您是我们平台的长期用户或者经销商，请正确填写以下信息，并且不要反复随意更改，以免造成后期订单收货信息错误。请仔细核对每次报价订单与采购订单的相关信息，避免造成不必要的损失。</p>
					<p class="acct-phone">咨询电话 <strong>0514-82106899</strong></p>

					<section class="acct-section">
						<h2 class="acct-section__title">编辑资料</h2>
						<el-form ref="infoForm" label-position="top" :model="infoForm" :rules="rules" class="acct-form">
							<el-form-item label="用户昵称" prop="nickname">
								<el-input class="acct-input" :clearable="clearable" placeholder="请输入用户昵称" v-model="infoForm.nickname"></el-input>
							</el-form-item>
							<el-form-item label="公司名称" prop="company_name">
								<el-input class="acct-input" :clearable="clearable" placeholder="请输入公司名称" v-model="infoForm.company_name"></el-input>
							</el-form-item>
							<el-form-item label="公司地址" prop="address">
								<el-input class="acct-input" :clearable="clearable" placeholder="请输入公司地址" v-model="infoForm.address"></el-input>
							</el-form-item>
							<el-form-item label="联系电话" prop="mobile">
								<el-input class="acct-input" :clearable="clearable" placeholder="请输入联系电话" v-model="infoForm.mobile"></el-input>
							</el-form-item>
							<div class="acct-actions">
								<button
									type="button"
									class="acct-btn acct-btn--primary"
									:class="{ 'is-loading': infoStatus }"
									@click="submitForm('infoForm')"
								>保存资料</button>
							</div>
						</el-form>
					</section>
				</div>
			</div>
		</common-body>
	</div>
</template>

<script>
	import { canAccessFrontRoute, readRuleList, resolveDefaultFrontRoute } from '@/utils/front-rules'

	function readLocalUserInfo() {
		try {
			return JSON.parse(localStorage.getItem('userInfo') || '{}') || {}
		} catch (e) {
			return {}
		}
	}

	export default {
		name: 'Center',
		data() {
			const validateMobile = (rule, value, callback) => {
				const mobile = String(value == null ? '' : value).trim()
				if (!mobile) {
					callback()
					return
				}
				if (!/^1\d{10}$/.test(mobile)) {
					callback(new Error('请输入正确的手机号'))
					return
				}
				callback()
			}
			const local = readLocalUserInfo()
			return {
				centerStatus: 1,
				clearable: !0,
				loading: !1,
				userInfo: local,
				infoStatus: !1,
				infoForm: {
					nickname: local.nickname || '',
					company_name: local.company_name || '',
					address: local.address || '',
					mobile: local.mobile || '',
				},
				rules: {
					nickname: [{
						required: true,
						message: '请输入用户昵称',
						trigger: 'blur'
					}],
					mobile: [{
						validator: validateMobile,
						trigger: 'blur'
					}],
				},
			}
		},
		computed: {
			displayName() {
				const info = this.userInfo || {}
				return info.nickname || info.username || '用户'
			},
			displayUserId() {
				const info = this.userInfo || {}
				const id = info.user_id != null && info.user_id !== '' ? info.user_id : info.id
				return id != null && id !== '' ? id : '—'
			},
			userInitial() {
				const name = this.displayName
				return String(name).charAt(0)
			},
		},
		created() {
			if (!canAccessFrontRoute('/center', readRuleList())) {
				const target = resolveDefaultFrontRoute(readRuleList())
				this.$router.replace(target || '/')
				return
			}
			this.reload();
		},
		methods: {
			applyUserinfo(data) {
				const prev = readLocalUserInfo()
				const next = Object.assign({}, prev, data || {})
				if (prev.token && !next.token) next.token = prev.token
				if (next.id != null && (next.user_id == null || next.user_id === '')) {
					next.user_id = next.id
				}
				this.userInfo = next
				this.infoForm.nickname = next.nickname || ''
				this.infoForm.company_name = next.company_name || ''
				this.infoForm.address = next.address || ''
				this.infoForm.mobile = next.mobile || ''
				localStorage.setItem('userInfo', JSON.stringify(next))
			},
			reload() {
				let that = this
				that.loading = !0
				that.$fetch('addons/hlm/api.User/getInfo').then(function(res) {
					if (res.code == 1 && res.data) {
						that.applyUserinfo(res.data)
					}
					that.loading = !1
				}).catch(function() {
					that.loading = !1
				})
			},
			submitForm(infoForm) {
				let that = this
				if (that.infoStatus) return
				that.$refs[infoForm].validate((valid) => {
					if (!valid) return false
					that.infoStatus = !0
					that.$fetch('addons/hlm/api.User/setNickname', {
						nickname: String(that.infoForm.nickname || '').trim(),
						company_name: String(that.infoForm.company_name || '').trim(),
						address: String(that.infoForm.address || '').trim(),
						mobile: String(that.infoForm.mobile || '').trim(),
					}).then(function(res) {
						if (res.code == 1) {
							if (res.data) that.applyUserinfo(res.data)
							else that.reload()
							that.$message({
								message: '修改成功',
								type: 'success',
								duration: 1500,
								center: !0
							})
						}
						that.infoStatus = !1
					}).catch(function() {
						that.infoStatus = !1
					})
				});
			},
			goUrl(e) {
				let that = this, status = e.currentTarget.dataset.status, url = e.currentTarget.dataset.url
				if (status != that.centerStatus) {
					that.$router.replace(url)
				}
			},
		}
	};
</script>

<style src='../assets/css/center.css'>
	/* px2rem能正常转换 */
</style>
